import styled, { css } from 'styled-components';
import Close from '@carvana/icons/Close';
import TooltipPosition from './TooltipPosition';

const ARROW_OFFSET = 10;

const leftArrow = css`
  left: ${ARROW_OFFSET}px;
`;

const rightArrow = css`
  right: ${ARROW_OFFSET}px;
`;

const downArrow = css`
  bottom: -8px;
  border-top: 8px solid ${p => p.theme.carvana.blue.dark};
  ${({ arrowPosition }) => arrowPosition === 'left' && leftArrow}
  ${({ arrowPosition }) => arrowPosition === 'right' && rightArrow}
`;

const upArrow = css`
  top: -8px;
  border-bottom: 8px solid ${p => p.theme.carvana.blue.dark};
  ${({ arrowPosition }) => arrowPosition === 'left' && leftArrow}
  ${({ arrowPosition }) => arrowPosition === 'right' && rightArrow}
`;

export const OuterWrapper = styled.div`
  position: absolute;
  width: ${({ contentWidth }) => (contentWidth !== null && `${contentWidth}px`) || 'auto'};
  max-width: 250px;
  ${TooltipPosition}
`;

export const InnerWrapper = styled.div`
  color: ${p => p.theme.carvana.white.primary};
  padding: 10px;
  position: relative;
  z-index: 500;
  background: ${p => p.theme.carvana.blue.dark};
  border-radius: 3px;

  &::after {
    content: '';
    position: absolute;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    ${({ direction }) => (direction === 'up' ? upArrow : downArrow)}
  }
`;

export const CloseIcon = styled(Close)`
  color: ${p => p.theme.carvana.white.primary};
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;
